import {Button} from 'platform/components';
import {HStack, Show, Spinner, Text} from 'platform/foundation';
import {match} from 'ts-pattern';

import type {ReactNode} from 'react';

import i18n from '@dms/i18n';

export interface CustomerInsightsEnrichmentStatusProps {
  isLoading: boolean;
  isError: boolean;
  retry: VoidFunction;
  children: ReactNode;
}

/**
 * Keeps enrichment failures visible while preserving safe record-projected
 * values. A failed enrichment never turns into an empty section or silently
 * replaces an existing value; the user can retry the missing detail.
 */
export function CustomerInsightsEnrichmentStatus(props: CustomerInsightsEnrichmentStatusProps) {
  return match({isLoading: props.isLoading, isError: props.isError})
    .with({isLoading: false, isError: false}, () => props.children)
    .otherwise(() => (
      <HStack spacing={1} align="center" wrap aria-busy={props.isLoading}>
        {props.children}
        <Show when={props.isLoading}>
          <Spinner size="small" />
        </Show>
        <Show when={props.isError}>
          <HStack spacing={1} align="center">
            <Text size="xSmall" color="secondary">
              {i18n.t('general.labels.error')}
            </Text>
            <Button
              size="small"
              variant="link"
              title={i18n.t('general.actions.retry')}
              onClick={props.retry}
            />
          </HStack>
        </Show>
      </HStack>
    ));
}
